import React from 'react'

import { StyleButton } from './StyleButton'

import { inlineStyles } from './buttons'


export const InlineStyleControls = ({ editorState, onToggle }) => {

  const currentStyle = editorState.getCurrentInlineStyle()


  return (
    <div>
      {inlineStyles.map(type =>
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={onToggle}
          style={type.style}
          icon={type.icon}
        />
      )}
    </div>
  )
}
